import request from '@/utils/request'
const apiPath = '/sys/systemNotice'
const sysNoticeApi = {
  /**
   * 新增【通知】
   */
  create(data) {
    return request.post(`${apiPath}/teev2/save`, data)
  },
  /**
   * 修改【通知】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【通知】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【通知】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【通知】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【通知】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【通知】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
}
export default sysNoticeApi
